export default __webpack_public_path__ + "static/media/IS_Voice_Memo_Prototype.62c3922b.jpg";